import { render } from "./default.vue?vue&type=template&id=6d0c085a&scoped=true&ts=true"
import script from "./default.vue?vue&type=script&lang=ts&config=true"
export * from "./default.vue?vue&type=script&lang=ts&config=true"

import "./default.vue?vue&type=style&index=0&id=6d0c085a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d0c085a"]])

export default __exports__